import API from "../../restAPI";
const Api = new API();

export default class ClientsAPI {
  // get all clients
  getClientList(payload) {
    return Api.request("/client-list", payload, "POST");
  }

  // get all clients
  getAllClients(payload) {
    return Api.request("/pr-clients", payload, "GET");
  }

  // get client details
  getClientInfo(id) {
    return Api.request("/fetch-client-details/" + id, [], "GET");
  }

  // add asset details
  addClient(payload) {
    return Api.request("/pr-create-client", payload, "post");
  }

  // update asset details
  updateClient(id, payload) {
    return Api.request("/update-client-By-Id/" + id, payload, "patch");
  }

  // update asset details
  deleteClient(id, payload) {
    return Api.request("/delete-client/" + id, payload, "patch");
  }

  //Handle Duplicate Client Email
  handleDuplicateClientEmail(email) {
    return Api.request(
      `/pr-users/count`,
      {},
      "GET",
      `where=%7B%22email%22%3A%22${email}%22%2C%22isDeleted%22%3A0%7D`,
    );
  }

  // get all clients basic info
  getAllClientBasics(payload) {
    return Api.request("/client-basics", payload, "POST");
  }
}
